export default __webpack_public_path__ + "static/media/lineal.ff7c0439.svg";